import httpHelper from '../../../../utils/httpHelper';
import { appConfig } from '../../../../constants/appConfig';

const service = {

  async getProductList(params) {
    const endPoint = `product/getProductList`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getProductByBarcodeNumber(params) {
    const endPoint = `product/findProductByBarcodeNumber?barcodeNumber=${params.barcodeNumber}`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async saveProduct(payload) {
    const endPoint = 'product/saveProduct';
    const result = await httpHelper.makePostRequest(
      appConfig.baseUrl,
      endPoint,
      payload,
    );
    return result;
  },

  async deleteProduct(params) {
    const endPoint = `product/delete?id=${params.id}`;
    const result = await httpHelper.makeDeleteRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async updateProduct(payload) {
    const endPoint = `product/updateProduct?productId=${payload.productId}`;
    const result = await httpHelper.makePutRequest(
      appConfig.baseUrl,
      endPoint,
      payload.data
    );
    return result;
  },

  async getProductWithSearch(params) {
    const endPoint = `product/findProductSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  }
};

export default service;
